



























import Vue from 'vue';

interface Items {
  text: string | number | object;
  value: string | number | object;
  disabled: boolean;
  divider: boolean;
  header: string;
}

export default Vue.extend({
  name: 'HubSelect',

  inheritAttrs: false,

  props: {
    height: {
      type: Number,
      default: 53,
    },
    items: {
      type: Array as () => Items[],
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    outline: {
      type: Boolean,
      default: false,
    },
    pill: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number, Object],
      required: true,
      default: '',
    },
  },

  data() {
    return {
      selectValue: this.value,
    };
  },

  watch: {
    value() {
      this.selectValue = this.value;
    },
    selectValue() {
      this.$emit('input', this.selectValue);
    },
  },
});
